import type { CommandResult } from '../domain/types';
import type { MessageKey } from '../i18n/en';

type Failure<T> = Extract<CommandResult<T>, { ok: false }>;

/** Message key for any failed command, including the conflict variant. */
export function failureKey<T>(r: Failure<T>): MessageKey {
  if ('messageKey' in r) return r.messageKey as MessageKey;
  return 'conflict.title';
}

export function failureParams<T>(r: Failure<T>): Record<string, string | number> | undefined {
  return 'params' in r ? (r.params as Record<string, string | number> | undefined) : undefined;
}
